export enum TaskName {
    CheckAbandonedBotsTask = 'CheckAbandonedBotsTask',
    FileScanTask = 'FileScanTask',
    SendMailTask = 'SendMailTask',
    MultisessionDetectTask = 'MultisessionDetectTask',
    ResolveReplyAction = 'ResolveReplyAction',
    SendBulkTemplateMessagesTask = 'SendBulkTemplateMessagesTask',
    /** Added just for consistency, but this if functionality to be removed soon */
    UnsubscribedTemporaryWebhook = 'UnsubscribedTemporaryWebhook',
    ExportTask = 'ExportTask',
}
